import { Box } from '@material-ui/core';

import { LoanApplicationCardFactory } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/components/LoanApplicationCardFactory';
import { WaterfallProcessingStrategyEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/entities/ProcessingStrategy/WaterfallProcessingStrategyEntity';
import { ProcessingStatus } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/types/ProcessingStatus';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { useScreen } from '@/hooks/useScreen';

interface WaterfallStrategyProps {
  processingStrategyEntity: WaterfallProcessingStrategyEntity;
  processingStatus: ProcessingStatus | null;
}

export const WaterfallStrategy = ({ processingStrategyEntity, processingStatus }: WaterfallStrategyProps) => {
  const { sm } = useScreen();

  const loanApplications = processingStrategyEntity.loanApplications;
  const paymentMethodConditions = processingStrategyEntity.paymentMethodConditions;

  if (!loanApplications || !paymentMethodConditions) {
    return <div>Loading...</div>;
  }

  // A single lender has no order to explain, so it gets no rail and no number (AUTO-156).
  const showRail = loanApplications.length > 1;
  // const railRows = showRail ? processingStrategyEntity.railRows() : [];

  return (
    <FlexColumn gridGap={16}>
      {loanApplications.map(
        (
          loanApplication,
          // index
        ) => {
          const card = (
            <LoanApplicationCardFactory
              loanApplication={loanApplication}
              processingStrategyEntity={processingStrategyEntity}
              paymentMethodConditions={paymentMethodConditions}
              processingStatus={processingStatus}
            />
          );

          if (!showRail) {
            return (
              <Box key={loanApplication.id} width="100%" minWidth={0}>
                {card}
              </Box>
            );
          }

          return (
            <FlexRow key={loanApplication.id} width={'100%'} gridGap={sm ? 12 : 8} alignItems={'stretch'}>
              {/* <ProcessingRail rows={railRows} index={index} /> */}
              <Box flexGrow={1} minWidth={0}>
                {card}
              </Box>
            </FlexRow>
          );
        },
      )}
    </FlexColumn>
  );
};
